import * as React from 'react';

import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { Tooltip } from '@lightspeed/flame/Tooltip';

import { createReactRenderer } from 'helpers/react-renderer';

import { IconHelp } from './utils';

import type { ShippingCostSource } from 'root/apps/PurchaseOrder/ShipmentHistory/types';

export const StyledBox = styled(Box)<{ location: ShippingCostSource }>`
  display: inline-block;
  margin-top: ${(props) => ` ${props.location === 'shipment' ? '4px' : '0'}`};

  > div {
    z-index: 100;
  }

  span {
    padding: 0 !important;
  }
`;
interface Props {
  location: 'order' | 'shipment';
  shippingCostSource: ShippingCostSource | undefined;
  // @NOTE orderShipmentID: sequenceNumber
  shipmentsWithShippingCost?: { [key: string]: number } | undefined;
}

const TooltipPurchaseOrderShippingCost: React.FC<Props> = ({
  shippingCostSource,
  location = 'order',
}) => {
  let message = '';

  if (shippingCostSource) {
    if (location === 'order') {
      message = ['none', 'order'].includes(shippingCostSource)
        ? `Use this to enter the total shipment cost of an order. This will be disabled if shipment costs have been entered on any records of shipments.`
        : 'You added shipment costs on a record of shipment. To add the total shipment cost here instead, change the shipment cost to zero on all records of shipment.';
    } else if (location === 'shipment') {
      message = ['none', 'shipment'].includes(shippingCostSource)
        ? 'Use this to enter the cost of this shipment. This will be disabled if total shipment costs have been entered on the purchase order.'
        : 'You added total shipment costs on the purchase order page. To add the shipment cost here instead, change the total shipment cost to zero on the purchase order page.';
    }
  }

  return message ? (
    <StyledBox location={location}>
      <Tooltip
        placement="top-start"
        // @ts-ignore
        content={
          <div style={{ maxWidth: 320 }}>
            <Text fontSize="12px" fontWeight="normal" lineHeight="1rem">
              {message}
            </Text>
          </div>
        }
      >
        <Box as="div" style={{ padding: '0 0 0 8px' }}>
          {IconHelp}
        </Box>
      </Tooltip>
    </StyledBox>
  ) : null;
};

const RenderedComponent = createReactRenderer({
  component: TooltipPurchaseOrderShippingCost,
  selector: '[data-react-root="TooltipShippingCost"]',
});

export default TooltipPurchaseOrderShippingCost;

history.onChangeState(
  [
    {
      name: 'purchase.views.purchase',
      form_name: 'view',
      tab: 'main',
    },
  ],
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
